import { render, staticRenderFns } from "./small.vue?vue&type=template&id=f9adc544&scoped=true"
import script from "./small.vue?vue&type=script&lang=js"
export * from "./small.vue?vue&type=script&lang=js"
import style0 from "./small.vue?vue&type=style&index=0&id=f9adc544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9adc544",
  null
  
)

export default component.exports